import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusComponent } from './status.component';
import { MaterialModule } from 'src/app/material.module';
import { AddStatusCerereComponent } from './add-status/add-status-cerere.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditStatusComponent } from './edit-status/edit-status.component';

@NgModule({
    declarations: [
        StatusComponent,
        AddStatusCerereComponent,
        EditStatusComponent,
    ],
    imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
    exports: [StatusComponent],
})
export class StatusModule { }
